import { ItemDocumentFinderThemeModeConfig } from './types';

const dark: ItemDocumentFinderThemeModeConfig = {
  itemDocumentFinder: {},
};

export default dark;
